export const STATE_CACHE_NAME = 'state';
